import React from 'react'
import { Button } from 'antd'
import styled from 'styled-components'
import { getChainData } from '../../../helpers/utilities'

export const PanelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const WalletInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
`

interface IConnectWallet {
  userData: any
  disconnect: any
  connect: any
  isDisconnecting: boolean
}

export const ConnectWallet = ({
  userData,
  connect,
  disconnect,
  isDisconnecting,
}: IConnectWallet) => {
  return (
    <PanelWrapper>
      {userData && (
        <WalletInfoWrapper>
          <p>{userData?.accounts}</p>
          <p>{getChainData(userData.chainId).name}</p>
        </WalletInfoWrapper>
      )}
      <Button
        type="primary"
        ghost={userData}
        onClick={userData ? disconnect : connect}
        loading={isDisconnecting}
      >
        {/* eslint-disable-next-line no-nested-ternary */}
        {isDisconnecting
          ? 'Disconnecting'
          : userData
          ? 'Disconnect'
          : 'Connect your wallet'}
      </Button>
    </PanelWrapper>
  )
}
